import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-forest" data-id="element-107" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto flex max-w-content flex-col gap-8 px-5 py-14 lg:flex-row lg:items-center lg:px-8 lg:py-16" data-id="element-108" data-mp="1o2vjmvsbez9q">
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-gold" aria-hidden="true" data-id="element-109" data-mp="221bxr7sibs1w">
          <ShieldCheckIcon className="h-7 w-7 text-forest-deep" data-id="element-110" data-mp="19eqwnfm8c1l5" />
        </span>
        <div className="max-w-3xl" data-id="element-111" data-mp="19co8l14n0ij2">
          <h2 className="font-display text-2xl font-black text-cream sm:text-3xl" data-id="element-112" data-mp="14g67cb8in2bh">
            Garantía de 7 días, sin vueltas
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-cream/80" data-id="element-113" data-mp="1j650fzl7rnk3">
            Descargás el material, hacés los primeros ejercicios y lo probás con
            tus propios números. Si no es lo que esperabas, nos escribís dentro
            de los 7 días y te devolvemos el 100% del importe. Sin formularios y
            sin explicaciones.
          </p>
        </div>
      </div>
    </section>;
}